module.exports = __webpack_public_path__ + "assets/img/icon.1dfe06be.png";